/**
 * 기능 ID : COMVRF002-20MS
 * ASIS : addCert.js line 1021 ~ 1049 , MA3CMMAAT001_101S
 */
import { useCallback, useEffect, useRef, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useGlobalErrorStore } from 'scbk-services';
import { ConfirmBox, InfoText } from 'scbk-ui-web';
import { useAutVrfAddCreateARSAuthNumber } from '../hooks/api/autVrfAdditionalHooks';
import { useAdditionalStore } from '../stores/useAdditionalStore';

const AdditionalARSStep2Component: React.FC = () => {
  const [authNum, setAuthNum] = useState('');

  // 다국어 처리
  const { t } = useTranslation();

  const { selectedARSTelNo } = useAdditionalStore();

  const { request: createARSAuthNumber } = useAutVrfAddCreateARSAuthNumber({
    onError: (error) => {
      useGlobalErrorStore.getState().setErrorInfo({ ...error, title: `!!!!${error.code}` });
    },
  });

  const execCreateARSAuthNumber = useCallback(async () => {
    const result = await createARSAuthNumber();

    if (result?.authNumber) {
      return result.authNumber;
    } else {
      console.log('error, ', result);
    }

    return null;
  }, []);

  const isEffect = useRef(false);
  useEffect(() => {
    if (isEffect.current) return;

    const init = async () => {
      const result = await execCreateARSAuthNumber();

      if (!result) return;

      setAuthNum(result);
    };

    init();
    isEffect.current = true;
  }, []);

  return (
    <>
      <h2 className="page-heading-title mb-12">
        <Trans
          t={t}
          i18nKey="AdditionalComponent.044"
          components={[<span className="block md:inline md:mr-1"></span>]}
        >
          <span className="block md:inline md:mr-1">전화요청 후 화면에 표시된</span>
          인증번호를 입력해 주세요
        </Trans>
      </h2>

      <dl className="flex flex-col gap-2 text-center mb-5">
        <dt className="body-md text-basic-04">{t('AdditionalComponent.045', '수신 전화번호')}</dt>
        <dd className="body-lg font-weight-medium text-basic-02">
          {selectedARSTelNo?.maskTelNo ?? ''}
        </dd>
      </dl>

      <ConfirmBox>{authNum}</ConfirmBox>

      <InfoText
        type="primary"
        text={t(
          'AdditionalComponent.046',
          '전화요청을 했는데 전화가 오지 않으면, 다시 시도해 주세요. 계속 연결이 되지 않으면 1588-1599가 착신 금지되어 있는지 확인해 주세요.',
        )}
        className="mt-3"
      />
    </>
  );
};

export default AdditionalARSStep2Component;
